/**
 * Helpers para validação de NIFs portugueses partilhados entre os 2 fluxos
 * de checkout (MY + CRM). Substitui as regex inline duplicadas em
 * `validateCheckout`, `PaymentMethodSelector`, `MyOrderPayment.jsx` e
 * backend `my_shop.py`.
 *
 * Convenção legacy IHTP:
 *   - NIF particular (PF): 9 dígitos, primeiro dígito 1, 2 ou 3.
 *   - NIF de empresa (PJ): 9 dígitos, primeiro dígito 5, 6, 8 ou 9.
 *   - NIFs com 1º dígito 4 ou 7 são especiais (heranças, herdeiros, ENI) e
 *     não são considerados empresa para efeitos do shop legacy.
 *
 * O Cofidis Pay só aceita NIFs particulares — daí ser onde mais precisamos
 * desta validação. Para outros checks (formato, dígito de controlo) deixamos
 * ao SP legacy validar; aqui a regra é só "é empresa para Cofidis?".
 */

/** @returns {boolean} true se o NIF tiver formato válido (9 dígitos numéricos). */
export function isValidNifFormat(nif) {
  const cleaned = (nif || '').toString().trim();
  return /^\d{9}$/.test(cleaned);
}

/**
 * Determina se um NIF pertence a uma empresa (pessoa colectiva) usando a
 * convenção legacy IHTP — primeiro dígito ≥ 5 (5, 6, 8, 9). Inclui o caso
 * especial 7 que o legacy original tratava como empresa para efeitos
 * Cofidis (mantém compat).
 *
 * @param {string} nif
 * @returns {boolean}
 */
export function isCompanyNif(nif) {
  const cleaned = (nif || '').toString().trim();
  if (!isValidNifFormat(cleaned)) return false;
  const first = parseInt(cleaned[0], 10);
  return first >= 5;
}
